import { useState } from "react";
import { Card, message } from "antd";
import Rate from "./../../../../components/common/rate";
import Trash from "../../../../assets/icons/trash.svg";
import DeleteMemberModal from "../../../../components/common/modalMember";
import { deleteService } from "../../../../api/service";
import ApplyVariantQuantityLimitModal from "../../../../components/common/applyVariantQuantityLimitModal";
import EditPencil from "../../../../assets/icons/editPencil";
import colors from "../../../../share/constants/constants";

const ServiceCard = ({
  services,
  business,
  clicked,
  subserviceClick,
  sub,
  showExtra = true,
  fetchData,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isApplyVariantQuantityLimitModalOpen, setIsApplyVariantQuantityLimitModalOpen] = useState(false);

  const showApplyVariantQuantityLimitModal = (id) => {
    setIsApplyVariantQuantityLimitModalOpen(true);
    setSelectedId(id);
  };

  const hideApplyVariantQuantityLimitModal = () => {
    setIsApplyVariantQuantityLimitModalOpen(false);
  };

  const showModal = (id) => {
    setIsModalOpen(true);
    setSelectedId(id);
  };

  const onCancelHandler = () => {
    setIsModalOpen(false);
    setSelectedId(null);
  };

  const onDeleteHandler = async () => {
    const res = await deleteService(selectedId);
    if (res) {
      message.success("Service has been deleted successfully!");
      await fetchData();
    }
    onCancelHandler();
  };

  return (
    <>
      <Card className="w-24 rounded-md mb-2 pb-1 hover:cursor-pointer drop-shadow relative">
        <div
          className="h-16 bg-cover bg-center relative rounded-md"
          style={{
            backgroundImage: `url(${
              services?.serviceImage ||
              services?.serviceDetails?.serviceCategoryId?.image ||
              services?.serviceCategoryId?.image
            })`,
          }}
        >
          <span className="bg-primaryOrange text-white ml-0.4 top-0.4 absolute rounded p-0.4 py-0">
            {services?.advertisementId ? "Promoted" : ""}
          </span>
          <div className="absolute flex gap-1" style={{ right: "5px", top: "5px" }}>
            <div
              className="border-none hover:cursor-pointer bg-white rounded-lg px-0.7 pt-0.7"
              onClick={() => showApplyVariantQuantityLimitModal(services?._id)}
            >
              <EditPencil color={colors.primaryPurple}/>
            </div>
            <div
              className="border-none hover:cursor-pointer bg-white rounded-lg px-0.4 pt-0.4"
              onClick={() => {
                showModal(services?._id);
              }}
            >
              <img src={Trash} alt="Delete Icon" />
            </div>
          </div>
        </div>
        <div className="ml-2">
          <p className="font-bold mb-0 text-md">
            {services?.serviceDetails?.serviceName ?? services?.serviceName}
          </p>
          {showExtra && (
            <p className="text-grey mt-0">
              {business?.businessAddress ??
                services?.businessId?.businessAddress}
            </p>
          )}
          {showExtra && (
            <Rate
              disabled={"disabled"}
              value={services?.serviceDetails?.avgRating || services?.avgRating}
            />
          )}

          <div className="flex">
            <p className="text-primaryOrange font-bold mt-0 mb-0 text-md">
              $
              {services?.serviceDetails?.discountedPrice ??
                services?.discountedPrice}
            </p>
            <p className="line-through font-bold mt-0 mb-0 text-md ml-1">
              ${services?.serviceDetails?.servicePrice ?? services?.servicePrice}
            </p>
          </div>
          {sub ? (
            <div>
              <span
                className="text-primaryPurple mt-0 mb-2 cursor-pointer"
                onClick={() => clicked(services?._id)}
              >
                {"See Sub-services"}
              </span>
              <p
                onClick={() => subserviceClick(services?._id)}
                className="cursor-pointer"
              >
                Convert this to Sub-service
              </p>
            </div>
          ) : (
            <p className="text-primaryPurple mt-0">{business?.businessName}</p>
          )}
        </div>
      </Card>

      {isModalOpen && (
        <DeleteMemberModal
          title="Delete Service"
          text="Are you sure you want to delete this service?"
          onCancel={onCancelHandler}
          onOk={onDeleteHandler}
        />
      )}

      {isApplyVariantQuantityLimitModalOpen && (
        <ApplyVariantQuantityLimitModal
          title="Apply Quantity Limit"
          onCancel={hideApplyVariantQuantityLimitModal}
          data={business}
          id={selectedId}
          getBusinessDetails={fetchData}
          service={services}
        />
      )}
    </>
  );
};
export default ServiceCard;
